








































import {Component, Mixins} from 'vue-mixin-decorator';

import NetworkDevices from '@/components/Networking/Device/NetworkDevices.vue';
import NetworkConnections from '@/components/Networking/Connection/NetworkConnections.vue';
import NetworkProfile from '@/components/Networking/Profile/NetworkProfile.vue';
import NetworkProfiles from '@/components/Networking/Profile/NetworkProfiles.vue';

enum Tab {
  Devices,
  Connections,
  Profiles,
}

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkProfiles, NetworkProfile, NetworkConnections, NetworkDevices},
})
export default class NetworkAdvancedPage extends Mixins<BaseComponent>(BaseComponent) {
  private selectedTab: Tab = Tab.Devices;

  private Tab = Tab;
}
